const CHARACTERS = 'abcdefghijklmnopqrstuvwxyz01234567890';

export const getRandomString = (size) => {
  return Array.from(crypto.getRandomValues(new Uint32Array(size)))
    .map((value) => CHARACTERS[value % CHARACTERS.length])
    .join('');
};

export const getRandomHexString = () => {
  const buffer = crypto.getRandomValues(new Uint8Array(16));
  const array = new Uint8Array(buffer);
  let result = '';

  for (let i = 0, max = array.length; i < max; i++) {
    const value = array[i].toString(16);
    result += (value.length === 1 ? '0' + value : value);
  }

  return result;
};
